import React, { FC } from 'react'
import RightArrowIcon from 'transfix-icons/build/RightArrowIcon'
import { Box, ButtonBase, Grid, Typography } from 'transfix-ui/core'
import { useBreakpointContext } from 'utils/context/BreakpointContext'
import { ITodo } from 'apps/fleet-planner/types'
import { DashboardListRowLocation } from '../DashboardListRowLocation'
import { useDashboardListRowStyles } from '../useDashboardListRowStyles'
import { TodosListRowMessage } from './TodosListRowMessage'

interface ITodosListRowProps {
  todo: ITodo
  onClick: (id: string) => void
}

export const TodosListRow: FC<ITodosListRowProps> = ({ onClick, todo }) => {
  const { isMobile } = useBreakpointContext()
  const { externalId, shipmentId, stops } = todo || {}
  const classes = useDashboardListRowStyles()

  const clickHandler = () => {
    onClick(shipmentId.toString())
  }

  return (
    <ButtonBase onClick={clickHandler} component='div' className={classes.buttonBase}>
      <Box className={classes.row}>
        <Grid container spacing={isMobile ? 2 : 5}>
          <Grid item md={4} xs={12}>
            <Typography
              className={classes.rowHeader}
              component='div'
              variant='overline'
              color='textSecondary'>
              Load #TFX-{externalId}
            </Typography>
            <DashboardListRowLocation stops={stops} />
          </Grid>
          <Grid item md={7} xs={12}>
            <Typography
              className={classes.rowHeader}
              component='div'
              variant='overline'
              color='textSecondary'>
              To Do
            </Typography>
            <TodosListRowMessage todo={todo} />
          </Grid>
          {!isMobile && (
            <Grid item xs={1} className={classes.rightArrow}>
              <RightArrowIcon size='large' />
            </Grid>
          )}
        </Grid>
      </Box>
    </ButtonBase>
  )
}
